import React from 'react';
import { Link, usePage } from '@inertiajs/react';
import type { SharedProps } from '../../types';
import type { ToolGroup } from '../../types/developers';
import { CLIENTS } from './clients';
import { topicPath } from './topics';
import { button, card, pageTitle, primaryButton } from './ui';

// /developers itself: pick a client. The three steps happen on that client's
// page, where the token is generated and used (spec E4).
const StartTopic: React.FC<{ groups: ToolGroup[] }> = ({ groups }) => {
  const { props } = usePage<SharedProps>();
  const toolCount = groups.reduce((n, g) => n + g.tools.length, 0);

  return (
    <>
      <h1 className={pageTitle}>把 asaptodo 接进你的 AI</h1>
      <p className="mt-2 text-[15px] text-gray-700">
        接上之后，AI 能直接查和改你的待办、每做完一件事记一条工作日志、搜和读你的 wiki。
      </p>

      <h2 className="mb-2.5 mt-7 text-base font-semibold text-gray-900">选你在用的那一个</h2>
      <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
        {CLIENTS.map((c) => (
          <Link key={c.slug} href={topicPath(c.slug)} className={card}>
            <span className="block font-semibold text-gray-900">{c.label}</span>
            <span className={`text-xs ${c.kind === 'claude_desktop' ? 'text-amber-700' : 'text-gray-500'}`}>{c.how}</span>
            <span className="absolute right-3 top-3 text-gray-400">→</span>
          </Link>
        ))}
      </div>
      <p className="mt-3 text-sm text-gray-700">
        每家一页，三步都在那一页里做完：<strong>拿 token → 复制一段 → 确认接上了</strong>。
      </p>
      {!props.auth.user && (
        <div className="mt-3 flex flex-wrap items-center gap-2.5">
          <Link href="/login" className={primaryButton}>
            登录
          </Link>
          <Link href="/register" className={button}>
            注册
          </Link>
          <span className="text-xs text-gray-500">要先有账号才能拿 token；这些页面不登录也能看完</span>
        </div>
      )}

      <h2 className="mb-2.5 mt-7 text-base font-semibold text-gray-900">Skills</h2>
      <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
        <Link href={topicPath('worklog-hook')} className={card}>
          <span className="block font-semibold text-gray-900">Worklog skills</span>
          <span className="text-xs text-gray-500">Claude Code 的 Stop hook</span>
          <span className="absolute right-3 top-3 text-gray-400">→</span>
        </Link>
      </div>

      <h2 className="mb-2.5 mt-7 text-base font-semibold text-gray-900">接上之后</h2>
      <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
        <Link href={topicPath('tools')} className={card}>
          <span className="block font-semibold text-gray-900">能做什么</span>
          <span className="text-xs text-gray-500">
            {toolCount} 个工具：{groups.map((g) => g.name).join(' / ')}
          </span>
          <span className="absolute right-3 top-3 text-gray-400">→</span>
        </Link>
        <Link href={topicPath('rules')} className={card}>
          <span className="block font-semibold text-gray-900">它会守的规则</span>
          <span className="text-xs text-gray-500">服务端发给 AI 的原文</span>
          <span className="absolute right-3 top-3 text-gray-400">→</span>
        </Link>
      </div>
    </>
  );
};

export default StartTopic;
